export const CHAT_SCRIPT_ID = 'connectScript';
export const CHAT_SCRIPT_SRC = '//apps.commbox.io/Scripts/connect.js';

/**
 * Configuration for chatbot client
 */
export interface ChatbotConfig {
	baseDomain: string;
	appsSubDomain: string;
	streamId: string;
	trackerStreamId: string;
	ta: string; // encrypted authentication token
	language?: string; // Optional, if you want to control it
	style?: string; // Optional
	// ... other BY.chat options
}

export interface ChatbotState {
	config: ChatbotConfig | null;
	isLoading: boolean;
	error: string | null;
	scriptLoaded: boolean;
}

// For BY.chat object on window
declare global {
	interface Window {
		BY?: {
			chat: (
				config: Partial<ChatbotConfig> & {
					streamId: string;
					ta: string;
				}
			) => void;
		};
		connectScriptLoaded?: boolean;
	}
}
